import React from 'react';
import {
  DashboardOutlined,
  ClockCircleOutlined,
  FolderOpenOutlined,
  CheckCircleOutlined,
  BellOutlined,
  ApartmentOutlined,
  TeamOutlined,
  UserSwitchOutlined,
  LockOutlined,
  SettingOutlined,
  UserOutlined,
  ThunderboltOutlined,
  DeploymentUnitOutlined,
  CloudServerOutlined,
} from '@ant-design/icons';

// Horizon est servi par le backend Laravel hors du préfixe /api.
const HORIZON_URL = `${import.meta.env.VITE_APP_API_URL.replace(/\/api\/?$/, '')}/horizon`;

export const NAV_GROUPS = [
  {
    key: 'personal',
    label: 'Mon espace',
    icon: <UserOutlined />,
    defaultOpen: true,
    items: [
      { to: '/', icon: <DashboardOutlined />, label: 'Tableau de bord', shortcut: 'G D' },
      { to: '/fil-actualite', icon: <ThunderboltOutlined />, label: "Fil d'actualité", shortcut: 'G H' },
      { to: '/mes-activites', icon: <ClockCircleOutlined />, label: 'Mes activités', shortcut: 'G V' },
      { to: '/mon-equipe', icon: <TeamOutlined />, label: 'Mon équipe' },
    ],
  },
  {
    key: 'gestion',
    label: 'Gestion',
    icon: <FolderOpenOutlined />,
    defaultOpen: true,
    items: [
      { to: '/affaire', icon: <FolderOpenOutlined />, label: 'Dossiers', permission: 'VIEW-AFFAIRES', shortcut: 'G F' },
      { to: '/tache', icon: <CheckCircleOutlined />, label: 'Tâches', permission: 'VIEW-TACHES', shortcut: 'G X' },
      { to: '/activite', icon: <BellOutlined />, label: 'Rappels & Activités' },
    ],
  },
  {
    key: 'organisation',
    label: 'Organisation',
    icon: <ApartmentOutlined />,
    defaultOpen: false,
    items: [
      { to: '/departement', icon: <ApartmentOutlined />, label: 'Départements & Services', permission: 'VIEW-DEPARTEMENTS' },
      { to: '/personnel', icon: <TeamOutlined />, label: 'Personnels & Agents', permission: 'VIEW-PERSONNELS' },
    ],
  },
  {
    key: 'admin',
    label: 'Administration',
    icon: <SettingOutlined />,
    defaultOpen: false,
    items: [
      { to: '/user', icon: <UserSwitchOutlined />, label: 'Utilisateurs & Comptes', permission: 'VIEW-USERS' },
      { to: '/groupe', icon: <LockOutlined />, label: 'Sécurité & Permissions', permission: 'VIEW-GROUPS' },
      { to: '/settings', icon: <SettingOutlined />, label: 'Paramètres', permission: 'VIEW-SETTINGS' },
      { href: HORIZON_URL, icon: <DeploymentUnitOutlined />, label: 'Horizon (files d\'attente)', adminOnly: true, external: true },
      { to: '/deploiement', icon: <CloudServerOutlined />, label: 'Déploiements', adminOnly: true },
    ],
  },
];
